import '../../styles/sass/views/refactoy.scss';

import 'lightgallery';
import $ from "jquery";

$(document).ready(function () {
    $('.refactory-grid-picture').lightGallery({
        selector: '.refactory-gallery',
        cursor: 'crosshair',
        counter: false,
        autoplay: false,
        autoplayControls: false,
        download: false,
        fullScreen: true,
        enableSwipe: true
    });
})
